import V2Pagination from '@/common/components/Data/V2Pagination';
import styles from './index.module.less';
import { FC, useEffect, useState } from 'react';
import { isNotEmptyAny } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { chancePointPoiPage } from '@/common/api/expandStore/chancepoint';
import V2Empty from '@/common/components/Data/V2Empty';
import { distanceUnitConvert } from '@/common/utils/ways';
import cs from 'classnames';
import { Spin } from 'antd';

/**
 * @Description 创建机会点-周边门店-品牌列表
 */
const BrandList: FC<{
  tableFilter: any;
  curDetail: any;
  setCurDetail: any;
}> = ({
  tableFilter,
  curDetail,
  setCurDetail,
}) => {
  const [listData, setListData] = useState<any>([]);
  const [paginationConfig, setPaginationConfig] = useState<any>({
    page: 1,
    size: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isNotEmptyAny(tableFilter)) {
      methods.getBrandList();
    }
  }, [tableFilter]);

  const methods = useMethods({
    getBrandList(page = 1) {
      setLoading(true);
      chancePointPoiPage({ ...tableFilter, ...paginationConfig, page }).then((res) => {
        setListData(res.objectList || []);
        setPaginationConfig({ ...paginationConfig, page, total: res.totalNum });
      }).finally(() => setLoading(false));
    }
  });

  return (
    <div className={styles.brandListWrap}>
      { loading && <Spin /> }
      { !loading && !!listData.length && (
        <div className={styles.brandListContent}>
          <div className={styles.brandList}>
            { listData.map((item, index) => (
              <div
                className={cs(styles.brandListItem, (curDetail?.lat === item.lat && curDetail?.lng === item.lng && curDetail?.address === item.address) && styles.brandListItemActive)}
                key={index}
                onClick={() => setCurDetail(item)}
              >
                <img className={styles.brandListItemImage} src={item.logo} />
                <div className={styles.brandListItemContent}>
                  <div className={styles.contentTitle}>
                    <div className={styles.titleText}>{ item.name }</div>
                    <div className={styles.titleDistance}>{ distanceUnitConvert(item.distance) }</div>
                  </div>
                  <div className={styles.contentAddress}>{item.address }</div>
                </div>
              </div>
            )) }
          </div>
          <V2Pagination
            className={styles.brandPagination}
            total={paginationConfig.total}
            current={paginationConfig.page}
            pageSize={paginationConfig.size}
            simple
            onChange={(val) => {
              setPaginationConfig({ ...paginationConfig, page: val });
              methods.getBrandList(val);
            }}
          />
        </div>
      ) }
      { !loading && !listData.length && <V2Empty /> }
    </div>
  );
};

export default BrandList;
